import { getEverLoggedIn } from 'dibs-cookie-jar';
import { graphql, fetchQuery_DEPRECATED as fetchQuery } from 'react-relay/legacy';

// helpers
import { wasPdpVisitedMultipleTimes } from '../pdpSharedNotificationHelpers';
import { getItemIdFromUri } from '../../../utils/getItemIdFormUri';
import { PRIORITIES, SHOW_MULTI_PDP_VISITS } from '../pdpSharedNotificationConstants';
import { setModalShown, wasModalShown } from './helpers';

/**
 * Callout Workflow
 * 1. Check user, if modal has ever been displayed and registration limit. Returns true if:
 *    - User has never logged in.
 *    - Multiple Pdp visit modal has never been displayed.
 *    - Pdp page has been visited at least three times in current session.
 *    - Is not a Pdp preview page
 *
 * 2. If step 1 returns true, check item.
 *    - Return true if item:
 *          1. is available
 *          2. not on sale
 *          3. not an auction item
 *          4. favoriting is enabled
 */

const { MULTI_PDP_VISITS: MULTI_PDP_VISITS_PRIORITY } = PRIORITIES;

const query = graphql`
    query pdpSharedNotificationMultiplePdpVisitsModalConfigQuery($itemIds: [String]!) {
        viewer {
            itemRead(itemIds: $itemIds) {
                ... on Item {
                    isAuctionEnabled
                    isPrivateVisibilityType
                    status
                    pricing {
                        bargain
                    }
                }
            }
        }
    }
`;

export const pdpSharedNotificationMultiplePdpVisitsModalConfig = {
    name: 'saveToFolderCallout',
    priority: MULTI_PDP_VISITS_PRIORITY,

    rule: ({ relayEnvironment, store }) => {
        const { isPdpRespPreviewPage } = store?.getState()?.isPdpRespPreviewPage || {};
        const itemId = getItemIdFromUri(location.pathname);

        if (!itemId) {
            // could not get a item Id, exit out
            return Promise.resolve(false);
        }

        if (
            getEverLoggedIn(document.cookie) ||
            wasModalShown() ||
            !wasPdpVisitedMultipleTimes({ itemId } || isPdpRespPreviewPage)
        ) {
            return Promise.resolve(false);
        }

        return fetchQuery(relayEnvironment, query, { itemIds: [itemId] }).then(response => {
            const { itemRead } = response?.viewer || {};
            const item = itemRead?.[0] || {};
            const { pricing, status, isPrivateVisibilityType, isAuctionEnabled } = item;
            const bargain = pricing?.bargain;

            if (
                bargain ||
                status === 'UNAVAILABLE' ||
                isPrivateVisibilityType ||
                isAuctionEnabled
            ) {
                return false;
            }
            return true;
        });
    },

    action:
        ({ runNextNotification }) =>
        dispatch => {
            setModalShown();
            dispatch({
                type: SHOW_MULTI_PDP_VISITS,
                runNextNotification,
            });
        },
};
